import { sortBy } from "lodash";
import { INVENTORIES_ORDER } from "../constants/shop";
import { Inventory, InventoryStatus } from "@onmo/graphql/graphql";

const getInventoryImage = (inventory?: Inventory) => {
  if (inventory?.data?.__typename === "InventoryBundleData") {
    return inventory?.data.previewUrl;
  } else return inventory?.data.url;
};

const sortAvatars = (avatars?: Inventory[]) => {
  if (!avatars) return;
  const addNewTypeInventory = (inventory: Inventory) => {
    if (inventory.isPurchased) {
      return "shop_Purchased";
    } else if (inventory.status === InventoryStatus.Restricted) {
      return "common_Premium";
    } else if (!inventory?.prices?.length) {
      return "common_Free";
    } else return "shop_Paid";
  };

  const newAvatars = sortBy(
    avatars?.map((avatar) => {
      return {
        ...avatar,
        type: addNewTypeInventory(avatar),
      };
    }),
    (item) => INVENTORIES_ORDER.indexOf(item.type),
  );
  return newAvatars;
};

// The CMS keys languages the Localazy way: a script after "#", a region after "_" (zh-Hant -> zh#Hant).
const toContentLanguageCode = (language: string) =>
  language
    .split("-")
    .map((part, index) => {
      if (index === 0) return part;
      return part.length === 4 ? `#${part}` : `_${part}`;
    })
    .join("");

export const getInventoryTitle = (inventory: Inventory, language: string) => {
  if (!inventory) return "";
  const translations = inventory.metadata?.translations;
  const translated = translations?.[toContentLanguageCode(language)]?.title;
  if (typeof translated === "string" && translated.trim()) return translated;

  // The old keys, renamed by the platform to `{languageName}Title`; drop this part with the old format.
  const regionName = new Intl.DisplayNames("en", {
    type: "language",
  });

  let keyTitle = regionName.of(language)?.toLowerCase();
  if (keyTitle === "bangla (bangladesh)") {
    keyTitle = "banglaBangladesh";
  }

  return translations?.[`${keyTitle}Title`] || inventory.title;
};

export const Inventories = {
  sortAvatars,
  getInventoryImage,
  getInventoryTitle,
};
